export const GET_FACILITY_SCREEN = 'facilityScreen/GET_FACILITY_SCREEN'
export const START_LOADING_FACILITY_SCREEN = 'facilityScreen/START_LOADING_FACILITY_SCREEN'
export const STOP_LOADING_FACILITY_SCREEN = 'facilityScreen/STOP_LOADING_FACILITY_SCREEN'
export const SET_FACILITY_SCREEN_STATUSES = 'facilityScreen/SET_FACILITY_SCREEN_STATUSES'
export const INVALIDATE_FACILITY_SCREEN = 'facilityScreen/INVALIDATE_FACILITY_SCREEN'
export const FACILITY_SCREEN_LOAD_FAILED = 'facilityScreen/FACILITY_SCREEN_LOAD_FAILED'
